<template>
    <div class="editInfo">
        <div class='con'>
            <van-field v-model="phone" type="tel" label="手机卡号码" placeholder="请输入设备SIM卡手机号码" @blur='checkData'/>
           
            <div class="btn"> 
                <div class="btn-primary" @click='handleClick'>确定</div>
            </div> 
        </div>
       <div class='loading' v-if="loading"><van-loading type="spinner" color="#fff" /></div>
    </div>
</template>
<script>
   import {updateContactPhone} from '@/api/api.mine.js';
    export default {
        data() {
            return {
                phone:this.$route.query.phone,
                loading:false,
            }
        },
        methods:{
            //手机号验证
            checkData(){
                let str=this.pubMethod.checkPhone(this.phone);
                if(this.phone&&!str)
                this.$toast('请输入正确手机号码');
            },
            handleClick(){
                    if(this.phone == ""){
                        this.$toast('请输入设备SIM卡手机号码')
                    }else{
                        this.loading=true;
                        updateContactPhone({
                            contactPhone:this.phone,
                            studentId:this.loginUser.studentId
                        }).then(data=>{
                            this.loading=false;
                            if(data.code=='00000'){
                                this.$toast('修改成功');
                                this.$router.go(-1);
                            }
                        })
                    }

             
            },
        }
    }
</script>
<style lang="scss" >
    .editInfo{
        padding:15px .15rem;
        height:100%;
        .con{
            position: relative;
            background:#fff;
            height:100%;
            border-radius:.1rem;
            padding:0rem .1rem;
            .van-cell{
                line-height: .34rem;
                font-size: .13rem;
                &::after{
                    border-bottom-color:#d8d8d8;
                }
                .van-field__control{
                    color:#666
                }
              
            }
            .note{
                margin:10px 16px;
                padding:13px;
                line-height: 22px;
                background:#f6f6f6;
            }
        }
        .btn{
            position: absolute;
            bottom: .25rem;
            text-align: center;
            width: 94%;
            left: 3%;
            .margin20{
                margin-right:.15rem;
            }
        } 
    }
</style>
